/** 
 *  Product Quiz
 * 
 *  Product Quiz utilising Gadget
 *  Use Query params to different settings.
 *  quizId
 */

/* ============================================================
   LOKALE QUIZ-ENGINE (2026-07-08) — Fork von product-quiz.js.
   Kein Gadget-Backend mehr: Fragen/Antworten kommen aus
   assets/hair-quiz-data.json, Empfehlungen aus UNSEREM Katalog
   (/products/<handle>.js), Ergebnis-Sharing via ?r=<base64>.
   Name/E-Mail sind uebersprungbar und verlassen den Browser NICHT
   (DSGVO). Rueckbau: page-quiz.liquid wieder auf product-quiz.js
   + Gadget-Script umhaengen. Original bleibt unangetastet im Repo.
   ============================================================ */
const WNW_QUIZ = window.WNW_QUIZ || {};
const wnwAsset = (p) => (p && p.indexOf('asset://') === 0) ? (WNW_QUIZ.assetBase || '/') + p.slice(8) : p;

const introductionTemplate = ({title, description, desktopImage, mobileImage, nextActionText, nextStepId, type, stepId}) => {
  return `
    <div class="quiz_screen_start item ${type} item-${stepId}" data-page-type="${type}">
    <div class="page-width--narrow">
      <div class="inner__data">
        <h1>${ title }</h1>
        <div>${ description.html }</div>
        <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
      </div>
    </div>
    ${ desktopImage && desktopImage.url ? `<img class="quiz__image" src="${ desktopImage.url }" alt="" />` : '' }
    ${ mobileImage && mobileImage.url ? `<img class="quiz__image--mobile" src="${ mobileImage.url }" alt="" />` : '' }
    <div></div>
  </div>
  `;
}

const inputTemplate = ({title, nextActionText, nextStepId, inputFieldLabel, inputFieldType, type, stepId}, pages) => {
 return `
 <div class="quiz__screen__one item ${type} item-${stepId}" data-page-type="${ type }">
 <h1>${ title }</h1>
 <div>

   <input type="${ inputFieldType }" required placeholder="${ inputFieldLabel }" name="${ inputFieldType === 'email' ? 'email' : 'name' }" />
 <div class="error"></div>
   ${ inputFieldType === 'email' ? `
   <label class="wnw-quiz-consent" style="display:flex;gap:10px;align-items:flex-start;justify-content:flex-start;box-sizing:border-box;width:100%;max-width:420px;margin:14px auto 0;padding:0 4px;font-size:13px;line-height:1.45;text-align:left;cursor:pointer;">
     <input type="checkbox" id="wnw-quiz-consent" style="appearance:auto;-webkit-appearance:checkbox;width:18px;height:18px;min-width:18px;max-width:18px;flex:0 0 18px;margin:1px 0 0;padding:0;display:inline-block;">
     <span style="flex:1 1 auto;min-width:0;display:inline-block;">Ja, schickt mir meine Quiz-Ergebnisse und Haarpflege-Tipps per E-Mail. Abmeldung jederzeit möglich.</span>
   </label>` : '' }
   </div>
   <button data-next-slide="${ nextStepId }">${ nextActionText }</button>

   <a data-next-slide="${ nextStepId }" data-skip class="quiz__screen-input-skip">${ inputFieldType == 'email' ? 'Ohne Angabe zu den Ergebnissen' : 'Überspringen' }</a>
   </div>
 `
}

const textTemplate = ({ title, description, nextActionText, nextStepId, type, desktopImage, mobileImage, stepId }) => {
  let data = `
  <div class="quiz_screen_start transparent__bg item ${type} item-${stepId}" data-page-type="${type}">
    <div class="back__btn">
      <a>
        <p>ZURÜCK</p>
        <img class="desktop-back-arrow"src="${wnwAsset('asset://quiz-back-arrow.png')}" alt="" />
        <img class="mobile-back-arrow"src="${wnwAsset('asset://quiz-back-arrow-mobile.png')}" alt="" />
      </a>
    </div>
    <div class="page-width--narrow">
      <div class="inner__data">
        <h1>${ title }</h1>
        <div class="inner--block--color">
          <div class="quiz__text__description">
            ${ description?.html ?? '' }
          </div>
          <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
        </div> 
      </div>
    </div>
    ${ desktopImage && desktopImage.url ? `<img class="quiz__image" src="${ desktopImage.url }" alt="" />` : '' }
    ${ mobileImage && mobileImage.url ? `<img class="quiz__image--mobile" src="${ mobileImage.url }" alt="" />` : '' }
  </div>`

  return data;
}

const questionTemplate = ({title, description, answers, nextActionText, nextStepId, type, id, stepId}) => {
  let formattedAnswers = answers.edges.map(({ node: answer }) => {
    let hasHoverImage = answer.hoverImage?.url != undefined
    return `
    <div class="question__answer">
    
          ${
            answer.image && answer.image.url ? 
            `<input type="radio" id="answer-${ answer.id }" name="question-${ id }" value="${ answer.id }" data-question="${ id }" data-tag="${ answer.tagToAdd }"/>
            <label for="answer-${ answer.id }" role="button" class="answer__images ${ hasHoverImage ? '' : 'answer__images--no-hover' }">
                <img
                   class="answer__image"
                  width="130"
                  src="${ answer.image?.url }"
                  alt=""
                >
                ${ hasHoverImage ? `
                <img
                class="answer__image-hover"
               width="130"
               src="${ answer.hoverImage?.url }"
               alt=""
             >` : ''
                }
               
              </label>
            ` : `
            
            <input type="radio" id="answer-${ answer.id }" name="question-${ id }" value="${ answer.id }" data-question="${ id }" data-tag="${ answer.tagToAdd }"/>
            <label for="answer-${ answer.id }" role="button" class="answer__images ${ hasHoverImage ? '' : 'answer__images--no-hover' }">
                <div style="width: 160px; border-radius: 9999px; background-color: green">not set</div>
              </label>
            `
          }  
        
        <div class="answer__label">
          <p>${ answer.text }</p>
          ${ answer.tooltip != null ? `
          <div class="answer__tooltip-icon">
           ${tooltipIcon}
            <span class="answer__tooltip-text">${ answer.tooltip }</span>
          </div>`: ''
        
        }
          
        </div>
      </div>
`
}).join(' ');
  return `
  <div class="quiz__screen__one quiz__page-question item ${type} item-${stepId}" data-page-type="${type}">
  <div class="back__btn">
    <a>
      <p>ZURÜCK</p>
      <img class="desktop-back-arrow"src="${wnwAsset('asset://quiz-back-arrow.png')}" alt="" />
      <img class="mobile-back-arrow"src="${wnwAsset('asset://quiz-back-arrow-mobile.png')}" alt="" />
    </a>
  </div>
    <h2 class="quiz__question-heading">${ title }</h2>
    <div class="question__answers">
      ${ formattedAnswers }
    </div>
    <div class="error"></div>
    <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
      </div>
  `
}

const resultTemplate = ({ questionAnswers }, recommendedProducts) => {
  let formattedProducts = recommendedProducts.map(( product ) => {
    return {
      id: product.id,
      variants: product.variants.edges.map(({ node: variant }) => ({ id: variant.id, image: variant.productImage, price: variant.price })),
      images: product.images.edges.map(({ node: image }) => ({ url: image.source, position: image.position })),
      tags: product.tags,
      title: product.title
    }
  });

  let shampooConditioner = formattedProducts.filter(product => product.tags.includes('QUIZ-SHAMPOO') || product.tags.includes('QUIZ-CONDITIONER'));
  let treatment = formattedProducts.filter(product => product.tags.includes("QUIZ-TREATMENT"));
  let miracle = formattedProducts.filter(product => product.tags.includes("QUIZ-MIRACLE"));
  let styling = formattedProducts.filter(product => product.tags.includes("QUIZ-STYLING"));
  let hairType = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("haartyp"));
  let hairTexture = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("haarstruktur"));
  let hairConcern = questionAnswers.edges.find(({ node }) => node.page.title.toLowerCase().includes("anliegen"));
  let hairGoal = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("aussehen"));
  console.log("formatted products", formattedProducts, shampooConditioner, hairType);

  
  return `<div>
 
  <div class="quiz__screen__sixteen">
  <div class="page-width-container">
    <div class="inner__content">
      <span>Empfohlen – nur für dich</span>
      <h1>Meine <span class="profile">Ergebnisse</span>
      </h1>
      <p>Jetzt, wo wir dein ${ hairTexture ? hairTexture.node.text : '' } Haar kennen, <br />kümmern wir uns um deine perfekte Routine</p>
    </div>
    <div class="flex--box">
    ${ hairType != undefined ?
      `<div class="content--block">
      <h2>Haar<span>typ</span>
      </h2>
      <p>${ hairType.node.text }</p>
    </div>`: ''
    }
    ${ hairTexture != undefined ?
      `
      <div class="content--block second_bck">
    <h2>Haar<span>struktur</span>
    </h2>
    <p>${ hairTexture.node.text }</p>
  </div>
      `: ''
    }

    ${ hairConcern != undefined ?
      ` <div class="content--block second_bck">
      <h2>Haar-<span>Anliegen</span>
      </h2>
      <p>${ hairConcern.node.text }</p>
    </div>`
    
    : ''
    }

  ${ hairGoal != undefined ? 
    `
    <div class="content--block third_bck">
    <h2>Haar-<span>Ziel</span>
    </h2>
    <p>${ hairGoal.node.text }</p>
  </div>

    `
  :''
  }
  </div>
</div>
  <div class="quiz__screen__sixteen_two">
  <div class="page-width-container">
    <div class="flex__bx">
      <div class="main__wrap">
        <h1>SHAMPOO & CONDITIONER 
        </h1>
        <div class="shampoo__block">
        
        ${ shampooConditioner.map((product) => {
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 

            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>
            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn" style="width:100%;height:auto;min-height:0;font-size:12px;line-height:1.3;padding:8px 4px;white-space:normal;">
             In den Warenkorb
            </button>
            </form>
          </div>
          `
        }).join('') }
        </div>
      </div>
      <div class="single__block tx_blck">
        <h1>TREATMENT 
        </h1>
        ${ treatment.map((product) => { 
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn" style="width:100%;height:auto;min-height:0;font-size:12px;line-height:1.3;padding:8px 4px;white-space:normal;">
             In den Warenkorb
            </button>
            </form>
          </div>
          `
        }).join('') }
      </div>
      <div class="single__block tx_blck">
      <h1>MIRACLE
        </h1>
      ${ miracle.map((product) => { 
        const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
          <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

          <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
          <input type="hidden" name="id" value="${product.variants[0].id}">
          <button type="submit" name="add" class="product-cart-btn" style="width:100%;height:auto;min-height:0;font-size:12px;line-height:1.3;padding:8px 4px;white-space:normal;">
           In den Warenkorb
          </button>
          </form>
        </div>
        `
      }).join('') }
      </div>
      <div class="main__wrap">
        <h1>STYLING 
        </h1>
        <div class="shampoo__block">
        ${ styling.map((product) => { 
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn" style="width:100%;height:auto;min-height:0;font-size:12px;line-height:1.3;padding:8px 4px;white-space:normal;">
             In den Warenkorb
            </button>
            </form>
          </div> 
          `
        }).join('') }
        </div>
      </div> 
      <div></div>
    </div>
    <a class="btn results-button" type="button" href="/cart/${ formattedProducts.map(product => product.variants[0].id + ':1')}?ref=from-quiz-result">
        <span class="atc-button--text">Ganze Routine in den Warenkorb</span><!--<span class="prod-cart-price-btn">$113.80</span>-->
      </a>
    <a href="/pages/hair-quiz" class="restart_txt">Quiz neu starten</a>
  </div>
</div>
</div>
  `

}

const tooltipIcon = `
<span class="tooltip_icon">?</span>`

function getQueryParams(){
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(params);
}

function stringToElement(string){
  const parser = new DOMParser();
  return parser.parseFromString(string, "text/html").body.firstElementChild;
}

const quizPagesToElements = (pages) => {
  pages.push({
    type: 'resultLoading'
  })
  return pages.map(page => {
    switch(page.type) {
      case "introduction":
        return stringToElement(introductionTemplate(page));
      case "input":
        return stringToElement(inputTemplate(page, pages));
      case "text":
        return stringToElement(textTemplate(page));
      case "question":
        return stringToElement(questionTemplate(page));
      case "result":
        return stringToElement(resultTemplate(page));
      default:
        return stringToElement(`<div class="item quiz__results__loading" style=""> <h2>Deine Ergebnisse werden geladen … Gut Ding braucht Weile</h2><br><div class="loading-mage"> <img src="${wnwAsset('asset://quiz-spinner.gif')}" alt="loading-icon" /></div></div>`)
    }
  })
}


async function begin() {
  const { r } = getQueryParams();
  if (r) {
    renderLocalResult(r);
    return;
  }
  const quiz = await fetch(WNW_QUIZ.dataUrl).then(res => res.json());
  (function resolveAssets(o){
    if (Array.isArray(o)) { o.forEach(resolveAssets); return; }
    if (o && typeof o === 'object') {
      if (typeof o.url === 'string') o.url = wnwAsset(o.url);
      Object.keys(o).forEach(k => resolveAssets(o[k]));
    }
  })(quiz);
  window.simon = quiz;
  console.log("We've got the quiz! ", {quiz});

  let quizData = {
    id: quiz.id,
    name: "",
    email: "",
    answers: [],
    answerIds: [],
    tags: []
  }

  window.quizData = quizData;


  const pages = quiz.pages.edges.map(edge => edge.node);
  console.log({pages})

  let carousel = document.createElement('wc-carousel-lite');
  window.carousel = carousel;
  // carousel.setAttribute('transition-duration', '1000'); 
  // carousel.setAttribute('center-between', ''); 
  // carousel.setAttribute('init-item', '3'); 


  carousel.append(...quizPagesToElements(pages))
  let quizEl = document.querySelector('#quiz')

  let progressBar = document.createElement('div');
  progressBar.classList.add('quiz__progress');
  progressBar.innerHTML = `<div class="quiz__progress__text"></div><div class="quiz__progress__bar" style="width: 0%"></div>`
  quizEl.append(progressBar);
  quizEl.append(carousel);

  document.querySelectorAll('[data-next-slide]').forEach(button => {
    button.addEventListener('click', event => {
      let nextSlide = event.target.getAttribute('data-next-slide');
      let parent = event.target.closest('.item');
      let type = event.target.closest('[data-page-type]').getAttribute('data-page-type');
      console.log("clicked", event.target, event.target.closest('[data-page-type]'), type);

      if(type == "introduction" || type == "text") {
        handleQuizNext(nextSlide, { quizData, pages });
      } else if(type == "input"){
        let input = parent.querySelector('input');
        let value = input.value;
        let isSkipLink = event.target.getAttribute('data-skip') != null;
        console.log("input value", event.target);
        if(isSkipLink){
          handleQuizNext(nextSlide, { quizData, pages });
          return;
        }
        if(input.reportValidity()){
          quizData[input.name] = value;
          parent.querySelector('input + .error').innerHTML = "";
          handleQuizNext(nextSlide, { quizData, pages });
        } else {
          console.log("Error they need to fill this in");
          parent.querySelector('input + .error').innerHTML = "Bitte prüfe deine Eingabe.";
        }
      } else if(type =="question"){
          let answersContainer = parent.querySelector('.question__answers');
          let isOneAnswerSelected = answersContainer.querySelector('input:checked') != null;
          if(isOneAnswerSelected){
            let selectedAnswer = answersContainer.querySelector('input:checked');
            quizData.answers.push({[selectedAnswer.dataset.question]: selectedAnswer.value});
            quizData.answerIds.push(selectedAnswer.value);
            if(selectedAnswer.dataset.tag){
              quizData.tags.push(selectedAnswer.dataset.tag);
            }
            handleQuizNext(nextSlide, { quizData, pages });
            parent.querySelector('.error').innerHTML = "";
          } else {
            console.log("Woah no answer selected here!")
            parent.querySelector('.error').innerHTML = "Bitte wähle eine Antwort!";
          }

          
      } else {
        console.log("It's something else")
      }


    })
  })

  document.querySelectorAll('.back__btn').forEach(button => {
    button.addEventListener('click', (ev) => {
      let previous = carousel.getPrevious();
      updateProgressBar(previous, carousel.getEntries().length);
      carousel.goPrevious();
    })
  })

  window.carousel = carousel;
}
 

const handleQuizNext =(nextSlideIndex, { quizData, pages } ) => {
  const isAtEnd = carousel.getIndex() + 1 == pages.length - 1;
  let nextIndex = nextSlideIndex;
  let carouselPages = carousel.getEntries();
  console.log("were on page", { nextIndex, isAtEnd})
  if((nextIndex == 'null' || nextIndex == pages.length) && isAtEnd) { 
    console.log("end?")
    nextIndex = pages.length - 1;
    createResult(quizData);
  } else {
    nextIndex = nextSlideIndex - 1;
    const conditionalTag = pages[nextIndex].conditionalTag ||= null;
    const isNextSlideConditional = conditionalTag != null;
    const meetsCondition = quizData.tags.includes(conditionalTag);
    console.log("isNextSlideConditional", { isNextSlideConditional, meetsCondition, conditionalTag, quizData });
  
    // Check if next slide is conditional
    if(isNextSlideConditional){
      if(!meetsCondition){
        nextIndex = nextIndex + 1;
      }
    }
    // Check if next slide is text and needs to be rendered.
    if(carouselPages[nextIndex].dataset.pageType == "text"){
      let el = carouselPages[nextIndex].querySelector('.quiz__text__description');
      let res = window.micromustache.render(el.innerHTML, quizData);
      el.innerHTML = res;
    }  
  }
  carousel.goto(nextIndex);
  updateProgressBar(carousel.getIndex(), carouselPages.length)
} 



const isEmpty = (str) => {
  return !str.trim().length
}

const updateProgressBar = (currIndex, totalSlides) => {
  let progressBar = document.querySelector('.quiz__progress__bar');
  let progressText = document.querySelector('.quiz__progress__text');
  let percentage = Math.round((currIndex / (totalSlides - 2)) * 100);
  progressBar.style.width = `${percentage}%`;
  progressText.innerHTML = `${currIndex}/${ totalSlides - 2}`;
}


const wnwCollectAnswers = (answerIds, pages) => {
  const out = [];
  pages.forEach(page => {
    (((page.answers || {}).edges) || []).forEach(({ node }) => {
      if (answerIds.indexOf(node.id) > -1) {
        out.push({ node: { text: node.text, page: { title: page.title }, recommendedProductIds: node.recommendedProductIds || [] } });
      }
    });
  });
  return out;
};

const wnwFetchProducts = async (handles) => {
  const seen = [];
  const out = [];
  for (const handle of handles) {
    if (!handle || seen.indexOf(handle) > -1) continue;
    seen.push(handle);
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error(res.status);
      const p = await res.json();
      out.push({
        id: String(p.id),
        handle: p.handle,
        title: p.title,
        tags: p.tags,
        images: { edges: (p.images || []).map((src, i) => ({ node: { source: src.indexOf('//') === 0 ? 'https:' + src : src, position: i + 1 } })) },
        variants: { edges: [{ node: { id: String(p.variants[0].id), productImage: null, price: (p.variants[0].price / 100).toFixed(2).replace('.', ',') } }] }
      });
    } catch (e) {
      console.warn('Quiz: Produkt nicht im Shop, wird ausgeblendet:', handle);
    }
  }
  return out;
};

/* Lokal: kein Backend-Write mehr. Antwort-IDs wandern in die URL (?r=…),
   damit das Ergebnis teil-/bookmarkbar bleibt. Name/E-Mail werden bewusst
   NICHT uebertragen oder gespeichert. */
const createResult = async ({ id, name, email, answers, ...quizData }) => {
  const answerIds = quizData.answerIds || [];
  const resultParam = btoa(JSON.stringify(answerIds));
  /* Klaviyo NUR mit eingegebener E-Mail UND explizitem Opt-in-Haekchen (DSGVO).
     Ohne Haekchen verlaesst nichts den Browser. */
  try {
    const consent = document.getElementById('wnw-quiz-consent');
    if (email && consent && consent.checked && window.klaviyo) {
      const pages = (window.simon && window.simon.pages) ? window.simon.pages.edges.map(e => e.node) : [];
      const qa = wnwCollectAnswers(answerIds, pages);
      const strip = (s) => String(s || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      const props = { 'Ergebnis-URL': location.origin + location.pathname + '?r=' + resultParam };
      const handles = [];
      qa.forEach(a => {
        props[strip(a.node.page.title)] = strip(a.node.text);
        (a.node.recommendedProductIds || []).forEach(x => { if (x && x.handle && handles.indexOf(x.handle) < 0) handles.push(x.handle); });
      });
      props['Empfehlungen'] = handles;
      const klCalls = [
        window.klaviyo.identify(name ? { email: email, first_name: name } : { email: email }),
        window.klaviyo.track('Hair Quiz Completed', props)
      ];
      /* Echtes Newsletter-Abo (Consent + ggf. Double-Opt-in) via Klaviyo Client API.
         Braucht die Listen-ID aus dem Section-Setting (Customizer > Hair Quiz). */
      if (WNW_QUIZ.klaviyoListId && WNW_QUIZ.klaviyoCompanyId) {
        klCalls.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(WNW_QUIZ.klaviyoCompanyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Hair Quiz',
                profile: { data: { type: 'profile', attributes: Object.assign(
                  { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
                  name ? { first_name: name } : {}
                ) } }
              },
              relationships: { list: { data: { type: 'list', id: WNW_QUIZ.klaviyoListId } } }
            }
          })
        }).then(res => { if (!res.ok) console.warn('Quiz: Klaviyo-Subscription HTTP ' + res.status); }));
      } else {
        console.warn('Quiz: keine Klaviyo-Listen-ID konfiguriert — nur Profil+Event, kein NL-Abo.');
      }
      await Promise.race([Promise.all(klCalls), new Promise(res => setTimeout(res, 2500))]);
    }
  } catch (e) { console.warn('Quiz: Klaviyo-Uebergabe fehlgeschlagen', e); }
  const url = new URL(window.location);
  url.searchParams.set('r', resultParam);
  url.searchParams.delete('quizId');
  window.location = url;
};

const renderLocalResult = async (r) => {
  let answerIds = [];
  try { answerIds = JSON.parse(atob(r)); } catch (e) { console.warn('Quiz: ungueltiger r-Parameter'); }
  const quizEl = document.querySelector('#quiz');
  quizEl.append(stringToElement(`<div class="item quiz__results__loading"><h2>Deine Ergebnisse werden geladen … Gut Ding braucht Weile</h2><br><div class="loading-mage"><img src="${wnwAsset('asset://quiz-spinner.gif')}" alt="" /></div></div>`));
  const data = await fetch(WNW_QUIZ.dataUrl).then(res => res.json());
  const pages = data.pages.edges.map(e => e.node);
  const questionAnswers = wnwCollectAnswers(answerIds, pages);
  const handles = questionAnswers.reduce((acc, a) => acc.concat((a.node.recommendedProductIds || []).map(x => x && x.handle)), []);
  const products = await wnwFetchProducts(handles);
  const loading = quizEl.querySelector('.quiz__results__loading');
  if (loading) loading.remove();
  quizEl.append(stringToElement(resultTemplate({ questionAnswers: { edges: questionAnswers } }, products)));
};

console.log(getQueryParams());
document.addEventListener("DOMContentLoaded", begin);



